import type { ListBuilderConfiguration } from '../types';

/**
 * Price Contract Client Embedded list configuration
 * Shows price contracts embedded in a client view
 * Converted from JSON to TypeScript for type safety
 */
export const PRICE_CONTRACT_CLIENT_EMBEDDED_CONFIG: ListBuilderConfiguration = {
	lists: [
		{
			id: 'default-price-contracts-client-embedded',
			cacheTTL: 600000,
			name: 'Client Price Contracts',
			type: 'default',
			active: true,
			sortOrder: 0,
			columns: [
				{
					id: 'name-contract-number',
					fields: [
						{
							id: 'name-field',
							link: {
								type: 'object',
								enabled: true,
								objectTable: 'price_contract',
								idField: 'id',
							},
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'name',
									objectTable: 'price_contract',
								},
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
						{
							id: 'line-break-1',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'line_break',
						},
						{
							id: 'contract-number-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'contractNumber',
									objectTable: 'price_contract',
								},
							},
							styleConfig: {
								size: 'xs',
								colorRule: {
									type: 'theme',
									themeColor: 'textSecondary',
								},
							},
							displayStyle: 'text',
						},
					],
					headers: [
						{ id: 'h1-1', text: 'Name' },
						{ id: 'h1-2', text: 'Contract #' },
					],
					minWidth: 200,
					sortable: true,
					alignment: 'left',
					sortFields: [
						{
							direction: 'ASC',
							fieldName: 'name',
							objectTable: 'price_contract',
						},
					],
					widthConfig: {
						mode: 'flexible',
						preset: 'large',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'status',
					fields: [
						{
							id: 'status-badge',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'status',
									objectTable: 'price_contract',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
					],
					headers: [{ id: 'h2', text: 'Status' }],
					minWidth: 120,
					sortable: false,
					alignment: 'center',
					widthConfig: {
						mode: 'flexible',
						preset: 'small',
					},
					verticalAlignment: 'middle',
				},
				{
					id: 'dates',
					fields: [
						{
							id: 'start-date-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'startDate',
									objectTable: 'price_contract',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'date',
						},
						{
							id: 'line-break-dates',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'line_break',
						},
						{
							id: 'end-date-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'endDate',
									objectTable: 'price_contract',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'theme',
									themeColor: 'textSecondary',
								},
							},
							displayStyle: 'date',
						},
					],
					headers: [
						{ id: 'h3-1', text: 'Effective Date' },
						{ id: 'h3-2', text: 'Expiration Date' },
					],
					minWidth: 180,
					sortable: true,
					alignment: 'left',
					sortFields: [
						{
							direction: 'ASC',
							fieldName: 'startDate',
							objectTable: 'price_contract',
						},
					],
					widthConfig: {
						mode: 'flexible',
						preset: 'medium',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'description',
					fields: [
						{
							id: 'description-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'description',
									objectTable: 'price_contract',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'theme',
									themeColor: 'textSecondary',
								},
							},
							displayStyle: 'text',
						},
					],
					headers: [{ id: 'h4', text: 'Description' }],
					minWidth: 250,
					sortable: false,
					alignment: 'left',
					widthConfig: {
						mode: 'flexible',
						preset: 'large',
					},
					verticalAlignment: 'top',
				},
			],
			defaultSortId: 'column-name-contract-number-asc',
		},
	],
	paging: {
		defaultPageSize: 25,
		pageSizeOptions: [10, 25, 50, 100],
	},
	filters: {
		activeFilters: ['priceContractKeywords', 'priceContractStatus'],
		defaultFilters: {},
	},
	objects: [
		{
			baseUrl: '/price-contracts/:id',
			objectLabel: 'Price Contract',
			objectTable: 'price_contract',
			selectedFields: [
				{ fieldName: 'id', fieldLabel: 'ID' },
				{ fieldName: 'name', fieldLabel: 'Name' },
				{ fieldName: 'contractNumber', fieldLabel: 'Contract Number' },
				{ fieldName: 'status', fieldLabel: 'Status' },
				{ fieldName: 'startDate', fieldLabel: 'Effective Date' },
				{ fieldName: 'endDate', fieldLabel: 'Expiration Date' },
				{ fieldName: 'description', fieldLabel: 'Description' },
			],
		},
	],
};
